import { render, staticRenderFns } from "./LpaInsutructions.vue?vue&type=template&id=217c4c14"
import script from "./LpaInsutructions.vue?vue&type=script&lang=js"
export * from "./LpaInsutructions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports